//      
import { useMemo } from 'use-memo-one';
                                   

let count         = 0;

                
                    
  

const defaults          = { separator: '::' };

export function reset() {
  count = 0;
}

export default function useUniqueId(
  prefix        ,
  options           = defaults,
)     {
  return useMemo(() => `${prefix}${options.separator}${count++}`, [
    options.separator,
    prefix,
  ]);
}



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-unique-id.js